// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-danger-dpu {
  background: #dc3545;
  border-color: #dc3545;
  color: #fff;
  padding: 0;
  height: 30px;
  width: 30px;
  padding: 4px 0px;
  outline: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-danger-dpu:hover {
  background: #bb2d3b;
  border-color: #b02a37;
  box-shadow: none;
  color: #fff;
}

.btn-danger-dpu svg {
  width: 100%;
  height: 100%;
  stroke: #fff;
  fill: #fff;
}

.btn-load-files-kmz {
  background: none;
  border: 1px solid #ced4da;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  min-width: 36px;
  min-height: 32px;
  color: var(--color-text-1);
}
.btn-load-files-kmz:hover {
  border: 1px solid var(--primary-color-hover-1);
  color: var(--primary-color-hover-1);
}
.btn-ok-modal {
  background: var(--primary-color-1);
  border: none;
  padding: 5px;
  min-width: 36px;
  min-height: 32px;
  cursor: pointer;
  border-radius: 5px;
  color: white;
  font-weight: 600;
}

.btn-ok-modal:hover {
  background: var(--primary-color-hover-1);
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.DPU-container-body-dialog {
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: var(--background-color-4);
}

.DPU-btn-defaut-style {
  background: var(--background-color-3);
  border-color: #adb1b8;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-sizing: border-box;
  border-radius: 4px;
  float: left;
  height: 25px;
  text-align: center;
  width: 25px;
  padding: 2px 2px;
  cursor: pointer;
}
.DPU-btn-defaut-style.disabled {
  cursor: no-drop;
  opacity: 0.5;
  pointer-events: none;
}

.DPU-btn-defaut-style svg {
  width: 100%;
  height: 100%;
  stroke: var(--color-text-3);
  fill: var(--color-text-3);
}

.DPU-btn-defaut-style:hover svg,
.DPU-btn-defaut-style.active svg {
  stroke: var(--primary-color-1);
  fill: var(--primary-color-1);
}

.DPU-btn-defaut-style:hover,
.DPU-btn-defaut-style.active {
  border-color: var(--primary-color-1);
}

.DPU-tooltip-mouse-move {
  font-size: 10px;
  position: absolute;
  display: none;
  transform: translate(2px, -100%);
  background-color: var(--background-color-1);
  padding: 4px;
  border-radius: 5px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--color-text-1);
}

.disable{
  cursor: no-drop;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/ultils.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":[".btn-danger-dpu {\r\n  background: #dc3545;\r\n  border-color: #dc3545;\r\n  color: #fff;\r\n  padding: 0;\r\n  height: 30px;\r\n  width: 30px;\r\n  padding: 4px 0px;\r\n  outline: none;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-danger-dpu:hover {\r\n  background: #bb2d3b;\r\n  border-color: #b02a37;\r\n  box-shadow: none;\r\n  color: #fff;\r\n}\r\n\r\n.btn-danger-dpu svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  stroke: #fff;\r\n  fill: #fff;\r\n}\r\n\r\n.btn-load-files-kmz {\r\n  background: none;\r\n  border: 1px solid #ced4da;\r\n  padding: 5px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  min-width: 36px;\r\n  min-height: 32px;\r\n  color: var(--color-text-1);\r\n}\r\n.btn-load-files-kmz:hover {\r\n  border: 1px solid var(--primary-color-hover-1);\r\n  color: var(--primary-color-hover-1);\r\n}\r\n.btn-ok-modal {\r\n  background: var(--primary-color-1);\r\n  border: none;\r\n  padding: 5px;\r\n  min-width: 36px;\r\n  min-height: 32px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n\r\n.btn-ok-modal:hover {\r\n  background: var(--primary-color-hover-1);\r\n}\r\n\r\n.disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.DPU-container-body-dialog {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 5px;\r\n  background-color: var(--background-color-4);\r\n}\r\n\r\n.DPU-btn-defaut-style {\r\n  background: var(--background-color-3);\r\n  border-color: #adb1b8;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-radius: 3px;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  float: left;\r\n  height: 25px;\r\n  text-align: center;\r\n  width: 25px;\r\n  padding: 2px 2px;\r\n  cursor: pointer;\r\n}\r\n.DPU-btn-defaut-style.disabled {\r\n  cursor: no-drop;\r\n  opacity: 0.5;\r\n  pointer-events: none;\r\n}\r\n\r\n.DPU-btn-defaut-style svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  stroke: var(--color-text-3);\r\n  fill: var(--color-text-3);\r\n}\r\n\r\n.DPU-btn-defaut-style:hover svg,\r\n.DPU-btn-defaut-style.active svg {\r\n  stroke: var(--primary-color-1);\r\n  fill: var(--primary-color-1);\r\n}\r\n\r\n.DPU-btn-defaut-style:hover,\r\n.DPU-btn-defaut-style.active {\r\n  border-color: var(--primary-color-1);\r\n}\r\n\r\n.DPU-tooltip-mouse-move {\r\n  font-size: 10px;\r\n  position: absolute;\r\n  display: none;\r\n  transform: translate(2px, -100%);\r\n  background-color: var(--background-color-1);\r\n  padding: 4px;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  color: var(--color-text-1);\r\n}\r\n\r\n.disable{\r\n  cursor: no-drop;\r\n  opacity: 0.5;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
